/**
 * The session flow's four screens, in the shape `registerRoutes` expects.
 *
 * Pattern note: `main.tsx` pre-registers `/session/:id`, and the router keeps a
 * key's original insertion order, so a later two-segment `/session/*` pattern
 * would be shadowed by it and never match. Setup therefore lives at `/setup`
 * rather than `/session/new`. The remaining patterns differ by segment count and
 * are unambiguous.
 */

import "./session.css";

import { Setup } from "./Setup.tsx";
import { Rating } from "./Rating.tsx";
import { Results } from "./Results.tsx";
import { Join } from "./Join.tsx";

export const sessionRoutes = {
  "/setup": Setup,
  "/session/:id": Rating,
  "/session/:id/results": Results,
  "/join/:code": Join,
};
